import React, { Component } from "react";
import { Card, Modal, Button, Form } from "react-bootstrap";
import AdminLayout from "../../components/adminLayout";
import { ROUTE_NAMES } from "../../Routes/routes";
import Loader from "../../components/Loader";
import api from "../../api";
import { storageServices } from "../../services/storage";
import { firebaseServices } from "../../services/firebase";
import { resp } from "../../services/responseHandler";
export default class Engage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userData: {},
      bizData: [],
      allFbPages: [],
      newFbPages: [],
      login_status: false,
      biz_id: "",
      isLoading: false,
      modalShow: false,
      loading: true,
    };

    const FB = window.FB;
    FB.init({
      appId: "281814379634072",
      autoLogAppEvents: true,
      xfbml: true,
      version: "v8.0",
    });

    FB.getLoginStatus(
      function (response) {
        console.log("status", response);
        if ((response.status === "unknown") || (response.status === "connected")) {
          this.setState({ login_status: true });
        } else {
          this.setState({ login_status: false });
        }
      }.bind(this)
    );
  }
  async componentDidMount() {
    var user = await storageServices.getCurrentUser();
    this.setState({ userData: user });
    await this.loadBizData();
  }
  addPages = async () => {
    console.log("login status", this.state.login_status);
    if (this.state.login_status) {
      await this.getPages();
    } else {
      await this.login();
    }
  };

  handleAddFbPages(event, data) {
    let list = [...this.state.newFbPages];
    if (event.target.checked) {
      list.push(data);
    } else {
      list = list.filter(function (obj) {
        return obj.id !== data.id;
      });
    }
    console.log("list", list);
    this.setState({ newFbPages: list });
  }
  getPages = async () => {
    const FB = window.FB;
    FB.api(
      "/me/accounts",
      async function (response) {
        console.log("response:",response);
        await this.setState({ allFbPages: response?.data });
        this.setState({ loading: false });
        this.showModal();
      }.bind(this)
    );
  };


  subscribePageFields = async (accessToken) => {
    const FB = window.FB;
    var body = {access_token : accessToken,subscribed_fields:"messages,messaging_postbacks,message_reads"}
    await FB.api(
      "/me/subscribed_apps",'post',body,
      async function (response) {
        console.log("fields:",response);
      }.bind(this)
    );
  };

  login = async () => {
    this.setState({ loading: true });
    const FB = window.FB;
    await FB.login(
      async function (response) {
        if (response.status === "connected") {
          console.log("connected");
          console.log(response);
          await this.getPages();
        } else if (response.status === "not_authorized") {
          console.log("not_authorized");
          this.setState({ loading: false });
          resp.Error("Not authorized!")
        } else {
          console.log("Unknown error");
          this.setState({ loading: false });
          resp.Error("Something went wrong!")
        }
      }.bind(this),
      {
        scope: "email,pages_show_list,pages_messaging,read_page_mailboxes",
        return_scopes: true,
        auth_type: "rerequest"
      }
    );
  };

  checkInitialSetup = (user) => {
    if (typeof user?.biz_id != "undefined") {
      return true;
    } else {
      return false;
    }
  };

  showModal = () => {
    this.setState({ modalShow: true });
  };
  hideModal = () => {
    this.setState({ modalShow: false });
  };

  insertFbPages = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    if (this.state.newFbPages.length !== 0) {
      var pages = await this.generateToken(this.state.newFbPages);

      var payload = {
        uid: this.state.userData?.uid,
        providerId: this.state.userData?.providerId,
        data: pages,
      };
      console.log("payload:", payload);
    
      await api.insertFacebookPages(payload).then(
        (res) => {
          console.log("Response:", res);
          this.setState({ loading: false });
          resp.ResponseHandler(res);
        },
        (error) => {
          console.log("error", error);
          this.setState({ loading: false });
          resp.ErrorHandler(error)
        }
      );
    }
    else{
      this.setState({ loading: false });
      resp.Error("No pages to add!")
    }
  };

  generateToken = async (pages) => {
    for (var i in pages){
    const client_id = "281814379634072";
    const client_secret = "a73ecf2816563f73df8f21ebc4226355";
    var access_token = pages[i].access_token;
    var url = `/v8.0/oauth/access_token?  
    grant_type=fb_exchange_token&          
    client_id=${client_id}&
    client_secret=${client_secret}&
    fb_exchange_token=${access_token}`;

    await api.getFBService(url).then(
      async(result) => {
        console.log("result", result);
        var accessToken = result.data.access_token
        pages[i].access_token = accessToken;
        await this.subscribePageFields(accessToken);
      },
      (error) => {
        console.log("error", error);
        resp.ErrorHandler(error);
      }
    );
    }
    return pages;
  };

  loadBizData = async () => {
    console.log("uid", this.state.userData.uid);
    await api.getBusinessByUid(this.state.userData.uid).then(
      (res) => {
        console.log("Business:", res);
        let biz_data = res.data.data;
        this.setState({ bizData: biz_data });
        storageServices.setBizData(biz_data);
        this.setState({ loading: false });
        // console.log("Business", biz_data);
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
      }
    );
  };

  viewFbPage(page_id, biz_id) {
    console.log("page_id", page_id, biz_id);
    this.props.history.push({
      pathname: "/fb_page",
      search: `?fb_page_id=${page_id}&biz_id=${biz_id}`,
    });
  }




  render() {
    const { history } = this.props;
    const { modalShow, default_bots, biz_bots, biz } = this.state;
    return (
      <AdminLayout>
        {this.state.loading ? <Loader /> : ""}
        <h3>Facebook Pages</h3>
        <hr />
        <div className="row mb-3">
          <div className="col">
            <div className="buttons float-right">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={this.login}
              >
                Add pages
              </button>
              {/* <button type="button" className="btn btn-outline-primary"  onClick={this.login}>Login</button> */}
            </div>
          </div>
        </div>
        <div className="row">
          {this.state.bizData.map((biz, index) => (
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card shadow-sm card-img-holder">
                <div
                  className="card-body mx-auto"
                  onClick={() => this.viewFbPage(biz.fb_page_id, biz.biz_id)}
                >
                  <img
                    className="img-thumbnail brand-logo-preview m-r-5"
                    src={`https://graph.facebook.com/${biz?.fb_page_id}/picture?type=normal`}
                  />

                  <button type="button" class="btn btn-link">
                    {biz?.biz_title}
                  </button>
                </div>
                {/* <div className="card-footer text-muted">
                  <div className="float-right">
                    <label className="switch">
                      <input
                        type="checkbox"
                        name={index}
                        checked={bot.enabled}
                        onChange={this.changeBotStatus}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div> */}
              </div>
            </div>
          ))}

          {/* <div className="col-md-4 stretch-card grid-margin">
            <div className="card shadow-sm card-img-holder">
              <div className="card-body mx-auto my-auto">
                <h3 className="text-secondary" onClick={this.showModal}>
                  <img src="https://img.icons8.com/flat_round/48/000000/plus.png" />
                </h3>
              </div>
            </div>
          </div> */}
        </div>

        <Modal
          show={modalShow}
          onHide={this.hideModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add pages</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card className="">
              <Card.Body>
                <Form onSubmit={this.insertFbPages}>
                  {this.state.allFbPages.map((page, index) => (
                    <>
                    <div class="form-check">
                    <input type="checkbox" class="form-check-input"
                    onChange={(e) => this.handleAddFbPages(e, page)}
                    name={page.id} id={page.id}/>
                    <label class="form-check-label" name={page.id} for={page.id}>{page.name}</label>
                  </div>

                    {/* <Form.Group>
                      <Form.Check
                        type="checkbox"
                        label={page.name}
                        name={page.id}
                        onChange={(e) => this.handleAddFbPages(e, page)}
                      />
                    </Form.Group> */}
                    </>
                  ))}
                  ;
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Modal.Body>
        </Modal>

        {/* <Col className="p-0 m-2 ">
          <CardDeck>
            {biz_bots.map((bot, index) => (
              <Card className="text-center">
                <Card.Body>
                  <Card.Title onClick={() => this.navBotPage(bot.id, bot)}>
                    {bot.title}{" "}
                  </Card.Title>
                </Card.Body>
              </Card>
            ))}
          </CardDeck>

          <Button variant="primary" size="lg" onClick={this.showModal}>
            Add
          </Button>

        
        </Col> */}
      </AdminLayout>
    );
  }
}
